export const FIREBASE_COLLECTION = {
  universes: 'universes',
  dashboards: 'dashboards',
};

export const FIREBASE_INDEXES = {
  equal: '==',
  not_equal: '!=',
  greater: '>',
  less: '<',
  greater_or_equal: '>=',
  less_or_equal: '<=',
  array_contains: 'array-contains',
};

export const FIREBASE_BOOLEAN = {
  true: true,
  false: false,
};

export const UNIVERSE_PROPERTIES = {
  universeId: 'universeId',
  accountId: 'accountId',
  isStaging: 'isStaging',
};

export const DASHBOARD_PROPERTIES_MODEL = {
  dashboardId: 'id',
  title: 'title',
  userEmails: 'userEmails',
  expiresTrialDate: 'expiresTrialDate',
  isPublished: 'isPublished',
  createdByAccessPage: 'createdByAccessPage',
};

export const DASHBOARD_PROPERTIES = {
  dashboardId: 'dashboardId',
  accountId: 'accountId',
  isStaging: 'isStaging',
  title: 'title',
  userEmails: 'userEmails',
  expiresTrialDate: 'expiresTrialDate',
  contractModel: 'contractModel',
  isPublished: 'isPublished',
  createdDate: 'createdDate',
  updatedDate: 'updatedDate',
  createdByAccessPage: 'createdByAccessPage',
};

export const DASHBOARD_DATE_PROPERTIES = {
  createdDate: 'audit.createdDate',
  updatedDate: 'audit.updatedDate'
};

export const UNIVERSE_PROPERTIES_OPTIONS = {
  isStaging: {
    staging: 'Homologação',
    prod: 'Produção',
    all: 'Todos',
  },
};

export const DASHBOARD_PROPERTIES_OPTIONS = {
  contractModel: {
    contract: 'Contratado',
    trial: 'Teste',
  },
  isPublished: {
    published: 'Ativo',
    inactive: 'Inativo',
  },
};

